"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonRedpacketSendControllByMap = exports.CommonRedpacketActivityRuleType = void 0;
const webapi_1 = require("@fegobull/webapi");
const lang_1 = require("../lang");
const { useToast } = webapi_1.use;
const Toast = useToast();
const $t = (0, lang_1.useI18n)();
var CommonRedpacketActivityRuleType;
(function (CommonRedpacketActivityRuleType) {
    /**
     * 其他组件发奖
     */
    CommonRedpacketActivityRuleType[CommonRedpacketActivityRuleType["OTHER_COMPONENT_SEND"] = 1] = "OTHER_COMPONENT_SEND";
    /**
     * 接口发奖
     */
    CommonRedpacketActivityRuleType[CommonRedpacketActivityRuleType["API_SEND"] = 2] = "API_SEND";
})(CommonRedpacketActivityRuleType || (exports.CommonRedpacketActivityRuleType = CommonRedpacketActivityRuleType = {}));
const BaseSendControll = async (methods, isForce // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    await methods.doSendRedpack();
};
const OtherComponentSendControll = async function (methods, isForce) {
    var _a, _b;
    if (isForce) {
        return BaseSendControll(methods, isForce);
    }
    (_b = (_a = methods.$callOtherComponentSendPrize).value) === null || _b === void 0 ? void 0 : _b.call(_a);
    return;
};
const BaseSendControllWithToast = async function (methods, isForce) {
    await BaseSendControll(methods, isForce);
    setTimeout(() => {
        Toast.success($t('message.sendSuccess'));
    }, 300);
};
exports.CommonRedpacketSendControllByMap = {
    [CommonRedpacketActivityRuleType.OTHER_COMPONENT_SEND]: OtherComponentSendControll,
    [CommonRedpacketActivityRuleType.API_SEND]: BaseSendControllWithToast
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkNBQXVDO0FBQ3ZDLGtDQUFrQztBQUVsQyxNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsWUFBRyxDQUFDO0FBQ3pCLE1BQU0sS0FBSyxHQUFHLFFBQVEsRUFBRSxDQUFDO0FBQ3pCLE1BQU0sRUFBRSxHQUFHLElBQUEsY0FBTyxHQUFFLENBQUM7QUFDckIsSUFBWSwrQkFTWDtBQVRELFdBQVksK0JBQStCO0lBQ3ZDOztPQUVHO0lBQ0gscUhBQXdCLENBQUE7SUFDeEI7O09BRUc7SUFDSCw2RkFBWSxDQUFBO0FBQ2hCLENBQUMsRUFUVywrQkFBK0IsK0NBQS9CLCtCQUErQixRQVMxQztBQStDRCxNQUFNLGdCQUFnQixHQUFrQixLQUFLLEVBQ3pDLE9BQXFCLEVBQ3JCLE9BQWdCLENBQUMsd0RBQXdEO0VBQzVELEVBQUU7SUFDZixNQUFNLE9BQU8sQ0FBQyxhQUFhLEVBQUUsQ0FBQztBQUNsQyxDQUFDLENBQUM7QUFFRixNQUFNLDBCQUEwQixHQUFrQixLQUFLLFdBQ25ELE9BQXFCLEVBQ3JCLE9BQWdCOztJQUVoQixJQUFJLE9BQU8sRUFBRSxDQUFDO1FBQ1YsT0FBTyxnQkFBZ0IsQ0FBQyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDOUMsQ0FBQztJQUNELE1BQUEsTUFBQSxPQUFPLENBQUMsNEJBQTRCLEVBQUMsS0FBSyxrREFBSSxDQUFDO0lBQy9DLE9BQU87QUFDWCxDQUFDLENBQUM7QUFFRixNQUFNLHlCQUF5QixHQUFrQixLQUFLLFdBQ2xELE9BQXFCLEVBQ3JCLE9BQWdCO0lBRWhCLE1BQU0sZ0JBQWdCLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0lBQ3pDLFVBQVUsQ0FBQyxHQUFHLEVBQUU7UUFDWixLQUFLLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxxQkFBcUIsQ0FBQyxDQUFDLENBQUM7SUFDN0MsQ0FBQyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0FBQ1osQ0FBQyxDQUFDO0FBRVcsUUFBQSxnQ0FBZ0MsR0FBMkQ7SUFDcEcsQ0FBQywrQkFBK0IsQ0FBQyxvQkFBb0IsQ0FBQyxFQUFFLDBCQUEwQjtJQUNsRixDQUFDLCtCQUErQixDQUFDLFFBQVEsQ0FBQyxFQUFFLHlCQUF5QjtDQUN4RSxDQUFDIn0=